export default function ConvertTimeStamp(XTimestamp, isDateObj = false) {
  const labeledTS = XTimestamp.replaceAll("TS", "");
  const SplitDate = labeledTS.split("X");
  const displayDate = `${SplitDate[0]}/${SplitDate[1]}/${
    SplitDate[2]
  } - ${convertHours()}`;
  // console.log("labeledTS", labeledTS);
  // console.log("SplitDate", SplitDate);
  // console.log("displayDate", displayDate);
  // console.log("new Date", new Date());

  function convert(str) {
    str = str.toString();
    return str.length === 1 ? `0${str}` : str;
  }
  function convertHours() {
    let Hours = parseInt(SplitDate[3]);
    let Minutes = parseInt(SplitDate[4]);
    if (Hours > 12) {
      return `${Hours - 12}:${convert(Minutes)} PM`;
    }
    if (Hours == 0) Hours = "12";
    return `${Hours}:${convert(Minutes)} AM`;
  }

  let dateSTR = `${SplitDate[0]}-${convert(SplitDate[1])}-${convert(
    SplitDate[2]
  )}T${convert(SplitDate[3])}:${convert(SplitDate[4])}:${convert(
    SplitDate[5]
  )}Z`;
  // console.log("dateSTR", dateSTR);
  const dateObj = new Date(dateSTR);
  // console.log("Date:", dateObj);
  if (isDateObj) return dateObj;
  return displayDate;
}
